import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)

Vue.config.productionTip = false

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAayzJl9LLpORlMghqTJPQ3phGQusrKlpk",
  authDomain: "lidar-87d6e.firebaseapp.com",
  databaseURL: "https://lidar-87d6e.firebaseio.com",
  projectId: "lidar-87d6e",
  storageBucket: "lidar-87d6e.appspot.com",
  messagingSenderId: "366866993140",
  appId: "1:366866993140:web:a9d4d12d4cdd6b6e"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

require("./assets/main.scss")

new Vue({
  router,
  render: h => h(App),
  created: function() {
    firebase.auth().onAuthStateChanged(user => {
      this.$router.push({name: 'home'})
    })
  }
}).$mount('#app')
